/**
 * События между плашкой согласия и ссылкой «Настройки cookie» в подвале.
 *
 * Отдельный крошечный модуль: подвал AiSearch общий с aisearch.ru, и его
 * скрипты не должны тянуть за собой код счётчиков. Здесь только имена.
 */

/** Ссылка «Настройки cookie» просит снова показать плашку. */
export const SOBYTIE_NASTROJKI = 'soglasie:nastrojki';

/** Плашка на странице есть: ссылка в подвале может появиться. */
export const SOBYTIE_GOTOV = 'soglasie:gotov';

declare global {
  interface Window {
    /** Подпись ссылки «Настройки cookie» на языке страницы. */
    __ga4Nastrojki?: string;
    /**
     * Счётчик GA4 на этом адресе возможен (боевой домен или флаг отладки,
     * не российский домен): плашку можно открыть. Ставит загрузчик плашки
     * до всякого согласия, сам gtag.js при этом не грузится.
     */
    __ga4Vozmozhen?: boolean;
  }
}
